import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { resolveNavBackgroundColor } from '../utils/navBackground';

const NAV_UI = {
  link: 'text-lumora-cream/70 hover:text-lumora-cream',
  icon: 'text-lumora-cream/70 hover:text-lumora-cream',
  menuBtn: 'text-lumora-cream',
};

export const useNavTheme = () => {
  const location = useLocation();
  const [headerBg, setHeaderBg] = useState('#0a0806');

  useEffect(() => {
    let rafId = 0;
    let lastColor = '';

    const applyColor = () => {
      const next = resolveNavBackgroundColor();
      if (next !== lastColor) {
        lastColor = next;
        setHeaderBg(next);
      }
    };

    const tick = () => {
      applyColor();
      rafId = requestAnimationFrame(tick);
    };

    applyColor();
    rafId = requestAnimationFrame(tick);
    window.addEventListener('resize', applyColor);

    const routeTimer = window.setTimeout(applyColor, 80);

    return () => {
      cancelAnimationFrame(rafId);
      window.clearTimeout(routeTimer);
      window.removeEventListener('resize', applyColor);
    };
  }, [location.pathname]);

  return {
    headerBg,
    ...NAV_UI,
  };
};
